export default __webpack_public_path__ + "static/media/home-menu-3.ef737f5a.png";